export const HomePageTestIds = {
  welcomeSvg: {
    file: "home.welcome.svg",
    cypress: "home\\.welcome\\.svg",
  },
  registerButton: {
    file: "home.register.button",
    cypress: "home\\.register\\.button",
  },
  loginButton: {
    file: "home.login.button",
    cypress: "home\\.login\\.button",
  },
  allRightsReserved: {
    file: "home.allRightsReserved.text",
    cypress: "home\\.allRightsReserved\\.text",
  },
};

export const SetupPageTestIds = {
  name1: {
    file: "setup.name1.input",
    cypress: "setup\\.name1\\.input",
  },
  name2: {
    file: "setup.name2.input",
    cypress: "setup\\.name2\\.input",
  },
  dob: {
    file: "setup.dob.input",
    cypress: "setup\\.dob\\.input",
  },
  gender: {
    file: "setup.gender.radio",
    cypress: "setup\\.gender\\.radio",
  },
  state: {
    file: "setup.state.select",
    cypress: "setup\\.state\\.select",
  },
  nextButton: {
    file: "setup.next.button",
    cypress: "setup\\.next\\.button",
  },
  education: {
    file: "setup.education.radio",
    cypress: "setup\\.education\\.radio",
  },
};
export const LoginPageTestIds = {
  phone: {
    file: "login.phone.input",
    cypress: "login\\.phone\\.input",
  },
  title: {
    file: "login.title.text",
    cypress: "login\\.title\\.text",
  },
  description: {
    file: "login.description.text",
    cypress: "login\\.description\\.text",
  },
  label: {
    file: "login.phone.label",
    cypress: "login\\.phone\\.label",
  },
  question: {
    file: "login.question.text",
    cypress: "login\\.question\\.text",
  },
  switch: {
    file: "login.switch.link",
    cypress: "login\\.switch\\.link",
  },
  submit: {
    file: "login.submit.button",
    cypress: "login\\.submit\\.button",
  },
  countrySelect: {
    file: "login.country.select",
    cypress: "login\\.country\\.select",
  },
  countryUsa: {
    file: "login.country.usa",
    cypress: "login\\.country\\.usa",
  },
  countryUkraine: {
    file: "login.country.ukraine",
    cypress: "login\\.country\\.ukraine",
  },
  countryIsrael: {
    file: "login.country.israel",
    cypress: "login\\.country\\.israel",
  },
};

export const GeneralTestIds = {
  logo: {
    file: "general.logo.svg",
    cypress: "general\\.logo\\.svg",
  },
  arr: {
    file: "general.arr.text",
    cypress: "general\\.arr\\.text",
  },
  option: {
    file: "general.state.option",
    cypress: "general\\.state\\.option",
  },
  errorMessage: {
    file: "general.message.error",
    cypress: "general\\.message\\.error",
  },
  toast: {
    file: "general.toast.error",
    cypress: "general\\.toast\\.error",
  },
  progressBar: {
    file: "general.progressBar.dots",
    cypress: "general\\.progressBar\\.dots",
  },
};

export const OtpPageTestIds = {
  wrapper: {
    file: "otp.wrapper.otp",
    cypress: "otp\\.wrapper\\.otp",
  },
  otp: {
    file: "otp.otp.input",
    cypress: "otp\\.otp\\.input",
  },
  title: {
    file: "otp.title.h2",
    cypress: "otp\\.title\\.h2",
  },
  label: {
    file: "otp.label.text",
    cypress: "otp\\.label\\.text",
  },
  question: {
    file: "otp.question.text",
    cypress: "otp\\.question\\.text",
  },
  button: {
    file: "otp.submit.button",
    cypress: "otp\\.submit\\.button",
  },
  sendAgain: {
    file: "otp.send.again",
    cypress: "otp\\.send\\.again",
  },
  updatePhone: {
    file: "otp.update.phone",
    cypress: "otp\\.update\\.phone",
  },
};

export const OnboardingTestIds = {
  title: {
    file: "onboarding.title.svg",
    cypress: "onboarding\\.title\\.svg",
  },
  description: {
    file: "onboarding.des.p",
    cypress: "onboarding\\.des\\.p",
  },
  button: {
    file: "onboarding.next.button",
    cypress: "onboarding\\.next\\.button",
  },
  stepTitle: {
    file: "onboarding.step.title",
    cypress: "onboarding\\.step\\.title",
  },
  stepMedia: {
    file: "onboarding.step.media",
    cypress: "onboarding\\.step\\.media",
  },
  stepButton: {
    file: "onboarding.step.button",
    cypress: "onboarding\\.step\\.button",
  },
  animation: {
    file: "onboarding.step.animation",
    cypress: "onboarding\\.step\\.animation",
  },
  allowPermissions: {
    file: "onboarding.allow.page",
    cypress: "onboarding\\.allow\\.page",
  },
  understandButton: {
    file: "onboarding.allow.button",
    cypress: "onboarding\\.allow\\.button",
  },
  settingsTitle: {
    file: "onboarding.title.h2",
    cypress: "onboarding\\.title\\.h2",
  },
  selectDevice: {
    file: "onboarding.selectDevice.select",
    cypress: "onboarding\\.selectDevice\\.select",
  },
  webcam: {
    file: "onboarding.webcam.video",
    cypress: "onboarding\\.webcam\\.video",
  },
  joinButton: {
    file: "onboarding.join.button",
    cypress: "onboarding\\.join\\.button",
  },
};

export const RotationTestIds = {
  svg: {
    file: "rotate.device.svg",
    cypress: "rotate\\.device\\.svg",
  },
  text: {
    file: "rotate.device.text",
    cypress: "rotate\\.device\\.text",
  },
};

export const PermissionsTestIds = {
  nextButton: {
    file: "permissions.first.button",
    cypress: "permissions\\.first\\.button",
  },
  finishButton: {
    file: "permissions.second.button",
    cypress: "permissions\\.second\\.button",
  },
  instructionStep: {
    file: "permissions.step.div",
    cypress: "permissions\\.step\\.div",
  },
  instructionTitle: {
    file: "permissions.title.p",
    cypress: "permissions\\.title\\.p",
  },
  instructionText: {
    file: "permissions.text.p",
    cypress: "permissions\\.text\\.p",
  },
  deviceIcon: {
    file: "permissions.device.icon",
    cypress: "permissions\\.device\\.icon",
  },
  component: {
    file: "permissions.component.p",
    cypress: "permissions\\.component\\.p",
  },
};

export const GetChannelTestIds = {
  section: {
    file: "getchannel.section.p",
    cypress: "getchannel\\.section\\.p",
  },
};
